export default [
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '*',
    redirect: 'error',
  },
]
